import React, { Component } from 'react';
import { do_action } from '../../actions';

class ModalUpdatePriceItemQuote extends Component {
    constructor(props) {
        super(props)
        this.state = {
            price: 0,
            old_price: 0
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.itemEdit && nextProps.itemEdit !== this.props.itemEdit) {
            this.setState({
                price: nextProps.itemEdit.price_unit.price,
                old_price: nextProps.itemEdit.price_unit.price
            })
        }
    }

    handleChange(e) {
        this.setState({
            price: e.target.value
        })
    }

    submitUpdatePrice(e) {
        e.preventDefault()
        let {itemEdit, vendor, total_price} = this.props;
        let {price} = this.state;
        if (!price)
            return alert('Please enter price')

        price = parseFloat(price)
        if (price < 0)
            return alert('Please enter valid number price')

        let item_id = itemEdit.items.item_id || itemEdit.items._id
        let type_item = itemEdit.price_unit.type_item == 2 ? 2 : 1

        let quote_room_id = itemEdit.quote_room_id
        quote_room_id = (typeof quote_room_id == 'string') ? quote_room_id : quote_room_id._id

        do_action('update_price_item_quote_vendor', { vendor_id: vendor._id, price, item_id, quote_id: itemEdit.quotes, quote_room_id, area_items_id: itemEdit.area_items_id })
            .then(data => {
                if (data.signal) {
                    let old_price = itemEdit.total_price
                    old_price = parseFloat(old_price)
                    let oldPriceUnit = itemEdit.price_unit.price
                    oldPriceUnit = parseFloat(oldPriceUnit)
                    total_price = parseFloat(total_price)
                    let new_price = (price * old_price) / oldPriceUnit
                    let new_total_price = total_price - old_price + new_price
                    new_total_price = new_total_price.toFixed(2)
                    new_price = new_price.toFixed(2)
                    let $ = window.$;
                    $('#modal-update-item-quotes').modal('hide');
                    this.setState({
                        old_price: price
                    })
                    this.props.updatePrice({item_quote: itemEdit._id, item_id, price, new_total_price, new_price, type_item, area_items_id: itemEdit.area_items_id, quote_room_id});
                }
            })
            .catch(err => console.log(err));
            
    }

    render() {
        let {itemEdit} = this.props;
        let {old_price, price} = this.state
        return (
            <div className="modal fade" id="modal-update-item-quotes" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
                <div className="modal-dialog" role="document">

                    <div className="modal-ruhu">
                        <div className="mdr-title">
                            <div className="text">Update Price</div>
                            <a href="#" data-dismiss="modal" className="closeX">
                                <img src="/images/icon-close.png" alt=""/>
                            </a>
                        </div>
                        {itemEdit && (
                            <div className="mdr-content">
                                <div className="form-group">
                                    <div className="clearfix vendor-item-update-modal">
                                        {/* <div className="pull-left img">
                                            <img src={itemEdit.url} alt="" className="img-responsive"/>
                                        </div> */}
                                        <div className="info">
                                            <div className="name">{itemEdit.items.title}</div>
                                            <div className="text-primary-kt fontSemiBold">{itemEdit.quantity_area}</div>
                                            <div className="text-gray-kt">{`$${old_price}/${itemEdit.items.type_price}`}</div>
                                        </div>
                                        <span className="icon-right fa fa-angle-right" role="button" onClick={this.props.nextItem}></span>
                                    </div>
                                </div>
                                <p className="fontMedium tit">New Price</p>
                                <div className="form-group">
                                    <input type="number" className="form-control form-control-mix" placeholder="Enter price..." value={price} onChange={this.handleChange.bind(this)} />
                                </div>
                                <div className="form-group">
                                    <a href="#" className="bg-blue btn-block text-center btn-blue" onClick={this.submitUpdatePrice.bind(this)}>Update</a>
                                </div>
                            </div>
                        )}
                    </div>


                </div>
            </div>
        );
    }
}

export default ModalUpdatePriceItemQuote;